
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.2 12.353h-1.8v-1.765c0-.468-.19-.917-.527-1.248a1.818 1.818 0 00-1.273-.516c-.477 0-.935.185-1.273.516-.337.331-.527.78-.527 1.248v1.765H27c-.477 0-.935.186-1.273.517-.337.33-.527.78-.527 1.248 0 .468.19.916.527 1.248.338.33.796.516 1.273.516h1.8v1.765c0 .468.19.917.527 1.248.338.33.796.517 1.273.517.477 0 .935-.186 1.273-.517.337-.331.527-.78.527-1.248v-1.765h1.8c.477 0 .935-.186 1.273-.516.337-.332.527-.78.527-1.248 0-.468-.19-.917-.527-1.248a1.819 1.819 0 00-1.273-.517zm-13.86 3.035a8.7 8.7 0 002.259-2.956 8.539 8.539 0 00.801-3.608c0-2.34-.948-4.585-2.636-6.24A9.092 9.092 0 0014.4 0c-2.387 0-4.676.93-6.364 2.584A8.737 8.737 0 005.4 8.824c0 1.245.273 2.476.801 3.608a8.698 8.698 0 002.259 2.956 14.324 14.324 0 00-6.158 5.204A13.918 13.918 0 000 28.235c0 .468.19.917.527 1.248.338.331.796.517 1.273.517.477 0 .935-.186 1.273-.517.337-.33.527-.78.527-1.248 0-2.808 1.138-5.501 3.163-7.487a10.91 10.91 0 017.637-3.1 10.91 10.91 0 017.637 3.1 10.484 10.484 0 013.163 7.487c0 .468.19.917.527 1.248.338.331.796.517 1.273.517.477 0 .935-.186 1.273-.517.337-.33.527-.78.527-1.248a13.918 13.918 0 00-2.302-7.643 14.324 14.324 0 00-6.158-5.204zm-5.94-1.27a5.477 5.477 0 01-3-.893A5.318 5.318 0 019.41 10.85a5.198 5.198 0 01-.307-3.06 5.263 5.263 0 011.478-2.71 5.434 5.434 0 012.764-1.449 5.5 5.5 0 013.12.301c.987.401 1.83 1.08 2.424 1.95.593.87.91 1.894.91 2.942 0 1.404-.569 2.75-1.582 3.743a5.455 5.455 0 01-3.818 1.55z"}})])
          )
        }
      }
    